var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60.914,
  height: 43.425,
  viewBox: "0 0 60.914 43.425"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M60.022 36.881h-1.309V4.461a.89.89 0 0 0-.892-.892h-2.975a.893.893 0 1 0 0 1.785h2.082v31.528H3.986V5.354h2.082a.893.893 0 0 0 0-1.785H3.093a.89.89 0 0 0-.892.892v32.42H.892a.89.89 0 0 0-.892.888v4.759a.89.89 0 0 0 .892.892h59.13a.89.89 0 0 0 .892-.892v-4.759a.89.89 0 0 0-.892-.892Zm-.892 4.759H1.785v-2.971h57.344Z",
  "data-name": "Path 756"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M51.277 0H9.636a.89.89 0 0 0-.892.892v5.056h43.425V.892A.89.89 0 0 0 51.277 0m-8.333 3.867h-.595a.893.893 0 1 1 0-1.785h.595a.893.893 0 1 1 0 1.785m4.759 0h-.595a.893.893 0 0 1 0-1.785h.595a.893.893 0 0 1 0 1.785",
  "data-name": "Path 757"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M37.893 19.928a7.436 7.436 0 1 0-14.872 0v7.436h6.543v-4.289a3.272 3.272 0 1 1 1.785 0v4.289h6.543Z",
  "data-name": "Path 758"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M18.262 29.148h24.389v3.569H18.262z",
  "data-name": "Rectangle 121"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.487,
  cy: 1.487,
  r: 1.487,
  fill: "#7654fd",
  "data-name": "Ellipse 23",
  transform: "translate(28.97 18.441)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M8.744 31.825a.89.89 0 0 0 .892.892h6.841v-4.461a.89.89 0 0 1 .892-.892h3.867v-7.436a9.22 9.22 0 0 1 18.441 0v7.436h3.867a.89.89 0 0 1 .892.892v4.461h6.841a.89.89 0 0 0 .892-.892V7.733H8.744ZM46.611 19.58a.89.89 0 0 1-.877.738 1 1 0 0 1-.156-.014l-2.344-.413a.892.892 0 1 1 .309-1.757l2.344.413a.89.89 0 0 1 .724 1.033m-.2-4.834a.89.89 0 0 1-.533 1.143l-2.235.814a.893.893 0 0 1-.612-1.678l2.237-.814a.89.89 0 0 1 1.143.534Zm-5.743-1.9 1.529-1.823a.892.892 0 1 1 1.367 1.147l-1.529 1.823a.892.892 0 1 1-1.367-1.147m-23.216-1.933a.893.893 0 0 1 1.258.111l1.534 1.825a.892.892 0 1 1-1.367 1.147l-1.533-1.823a.89.89 0 0 1 .111-1.257Zm-2.956 3.831a.89.89 0 0 1 1.143-.534l2.237.814a.893.893 0 0 1-.612 1.678l-2.235-.814a.89.89 0 0 1-.53-1.142Zm.527 3.8 2.344-.413a.892.892 0 1 1 .309 1.757l-2.344.413a1 1 0 0 1-.156.014.892.892 0 0 1-.153-1.771",
  "data-name": "Path 759"
})));
export default SvgAlert;